// extracted by mini-css-extract-plugin
export default {"price":"fca-z","onSale":"gca-z","msrpLabelPrice":"hca-z","msrpLabel":"ica-z","originalPrice":"jca-z"};